// Field Notes — the mastery vocabulary. One visual language for mastery
// state across chat, dashboards, and quiz surfaces.
//
// Ported from design/field-notes/tutor/glyphs.jsx (Direction A). The glyph
// is a "filling vessel": one hue progressing across 6 steps — the low end
// is neutral stone, never red. No-ambush is structural.
import './mastery.css';

export const MASTERY_LEVELS = [
  'novice', 'struggling', 'developing', 'proficient', 'advanced', 'mastered',
];

export const LEVEL_FILL = {
  novice: 12, struggling: 30, developing: 48,
  proficient: 66, advanced: 84, mastered: 100,
};

const LEVEL_VAR = {
  novice: 'var(--m-novice)',
  struggling: 'var(--m-struggling)',
  developing: 'var(--m-developing)',
  proficient: 'var(--m-proficient)',
  advanced: 'var(--m-advanced)',
  mastered: 'var(--m-mastered)',
};

export function MasteryGlyph({ level = 'novice', size = '' }) {
  const fill = LEVEL_FILL[level] ?? 12;
  return (
    <span
      className={'mglyph ' + size}
      data-level={level}
      role="img"
      aria-label={'mastery: ' + level}
      title={'mastery: ' + level}
    >
      <span
        className="mglyph-fill"
        style={{ height: fill + '%', '--fill': LEVEL_VAR[level] ?? LEVEL_VAR.novice }}
      />
    </span>
  );
}

export function MasteryChip({ level }) {
  return (
    <span className="mchip">
      <MasteryGlyph level={level} size="sm" />
      {level}
    </span>
  );
}

export function DueMarker() {
  return (
    <span className="due-marker" role="img" aria-label="due for review">
      <i />
    </span>
  );
}

export function BlockerMarker({ cls = '' }) {
  return (
    <span
      className={'blocker-marker ' + cls}
      role="img"
      aria-label="observed blocker"
    />
  );
}

// The defensibility moment: the tutor's memory made visible — accent used
// as a highlighter mark on "the thing that matters", never decoration.
export function BlockerNote({ concept = 'this', unlocks = [] }) {
  return (
    <div className="blocker-note">
      <BlockerMarker cls="bn-mark" />
      <div className="bn-text">
        <b>observed:</b>{' '}
        <span className="hl">you keep tripping on {concept}</span> —
        {unlocks.length
          ? <> clearing it unlocks <b>{unlocks.join(' & ')}</b>.</>
          : ' it’s pulling down everything downstream.'}
      </div>
    </div>
  );
}

export function StreakPill({ streak }) {
  if (!streak || !streak.current_streak) return null;
  return (
    <div className="streak-pill" title={'longest ' + (streak.longest_streak ?? streak.current_streak) + ' days'}>
      <span className="flame" /> <b>{streak.current_streak}</b>-day
    </div>
  );
}
